module.exports = __webpack_public_path__ + "static/sample_HARVEST_tablet_v2-f18177e3e4c74e65cec6852b52d1b025.png";